import { DEFAULT_REQUEST_HEADER, STORE_HEADER_SERVICES_URL } from "../../common/store-header-services-constants";
export function createCustomerContextCookie(customerContext, completeCallback) {
  const coordinates = customerContext.getCoordinates();
  if (!coordinates) {
    console.error('Missing coordinates for customer context cookie creation.');
    return;
  }
  let data = {
    'mainStore': customerContext.getMainStoreId(),
    'latitude': coordinates.getLatitude(),
    'longitude': coordinates.getLongitude()
  };
  if (customerContext.getPostcode()) data['postcode'] = customerContext.getPostcode();
  if (customerContext.getCity()) data['city'] = customerContext.getCity();
  lm.fetch({
    url: STORE_HEADER_SERVICES_URL + '/storeheader/customer-context-cookie',
    data,
    method: 'GET',
    credentials: 'same-origin',
    headers: DEFAULT_REQUEST_HEADER,
    complete: completeCallback
  });
}